import withTranslate from "@pathwright/ui/src/components/lng/withTranslate"
import { ConnectStores } from "lib/core/store"
import PropTypes from "prop-types"

import BlankSlate from "@pathwright/ui/src/components/blank/BlankSlate"
import Card from "@pathwright/ui/src/components/card/Card"
import LoadingCircle from "@pathwright/ui/src/components/loading/LoadingCircle"
import { useHomeRegistrationsLazyQuery } from "@pathwright/web/src/modules/api/generated"
import { useHomeRegistrationVars } from "@pathwright/web/src/modules/unified-home/HomeRegistrationQueryVars"
import { useState } from "react"

function GroupArchiveCard(props) {
  const [deleted, setDeleted] = useState(false)
  const [toContinue, setToContinue] = useState(null)
  const [groupName, setGroupName] = useState("")
  const [refetchHomeRegistrations] = useHomeRegistrationsLazyQuery({
    variables: useHomeRegistrationVars(),
    fetchPolicy: "network-only"
  })

  const handleArchive = () => {
    const {
      group,
      deleteGroup,
      preventModalClose,
      toContinue: propsToContinue
    } = props
    const name = group.name

    preventModalClose()
    return deleteGroup(group != null ? group.id : undefined).promise.then(
      () => {
        // TODO: remove cohort from CohortSwitcher cache
        // TODO: change these to remove the fragment from cache?
        // teach tab
        window.apolloClientStoreBridge.refetchTeachingResources()
        // design tab
        window.apolloClientStoreBridge.refetchResources({})
        // learn tab
        window.apolloClientStoreBridge.refetchRegistrations({})
        // library
        window.apolloClientStoreBridge.refetchLibraryResources()

        // new home screen registrations
        refetchHomeRegistrations()

        setDeleted(true)
        setToContinue(propsToContinue)
        setGroupName(name)
      }
    )
  }

  const {
    card,
    group,
    offering,
    loading,
    cardProps,
    toContinue: propsToContinue,
    continueLabel
  } = props

  return (
    <Card {...cardProps} card={card} hideClose={deleted}>
      {group ? (
        <BlankSlate
          icons={null}
          heading={props.t("cohort.cards.archive.blank_slate.heading")}
          body={props.t("cohort.cards.archive.blank_slate.body")}
          primaryAction={{
            children: props.t("cohort.cards.archive.blank_slate.button"),
            dangerous: true,
            onClick: handleArchive
          }}
          secondaryAction={{
            children: props.t("cohort.cards.archive.blank_slate.cancel"),
            onClick: card.onClose
          }}
        />
      ) : loading ? (
        <LoadingCircle />
      ) : deleted ? (
        <BlankSlate
          icons={null}
          heading={`"${groupName}" has been deleted`}
          primaryAction={{
            children: continueLabel,
            to: toContinue
          }}
        />
      ) : null}
    </Card>
  )
}

GroupArchiveCard.displayName = "GroupArchiveCard"
GroupArchiveCard.contextTypes = {
  me: PropTypes.object.isRequired
}

const mapStateToProps = function (state, ownProps) {
  const { group, group_loading } = state.groupAdminStore.state
  const { resource, offering, offering_loading } = state.resourceStore.state
  const { preventModalClose } = state.navigationStore.action
  const { getHomeLocation } = state.navigationStore.request
  const { modal_launched_from_url } = state.navigationStore.state
  const { deleteGroup } = state.groupAdminStore.action

  const cardProps = {
    title: group ? `Delete ${group.name}` : ""
  }

  const loading = group_loading || offering_loading
  let displayType = "Path"
  if (resource) {
    if (resource.resource_type === 30) displayType = "Collection"
    if (resource.resource_type === 20) displayType = "Lesson"
  }

  // TODO: in some cases it may be best to navigate back to /manage/resource/{resource_id}/group/
  // to show all groups (might only be if school has curriculum enabled and that card is actually open)
  let toContinue = null
  let curriculumUrl = null
  try {
    // get curriclum url
    const resourceUrl = state.resourceStore.request.resourceUrl()
    const curriculumOffering = state.resourceStore.request.curriculumOffering()
    curriculumUrl = resourceUrl.replace(/\/\d+\//, `/${curriculumOffering.id}/`)
    toContinue = curriculumUrl
  } catch (error) {
    toContinue = resource ? getHomeLocation() : modal_launched_from_url
  }

  const continueLabel =
    curriculumUrl || resource
      ? `Continue to ${resource ? displayType : "Home"}`
      : "Close"

  return _.assign(
    {},
    {
      // state
      group,
      loading,
      cardProps,
      continueLabel,
      // actions
      deleteGroup,
      preventModalClose,
      // routes
      toContinue
    },
    ownProps
  )
}

const connectStores = [
  { store: "navigation", watch: false },
  { store: "resource", watch: ["offering", "offering_loading"] },
  {
    store: "groupAdmin",
    watch: ["group_loading", "group"]
  }
]

export default withTranslate(
  ConnectStores(GroupArchiveCard, connectStores, {}, mapStateToProps)
)
